export default function createElement(tag = 'div', { attrs = {} }, ...children) {
  const $el = document.createElement(tag);
  const { textContent } = attrs;
  if (textContent) {
    children.unshift(document.createTextNode(textContent));
  }

  Object.entries(attrs).filter(([key]) => key !== 'textContent').forEach(([key, value]) => {
    $el[key] = value;
  });

  children.forEach((node) => {
    if (typeof node === 'string') {
      // eslint-disable-next-line no-param-reassign
      node = document.createTextNode(node);
    }

    $el.appendChild(node);
  });

  return $el;
}
